<main>
  <div class="d-grid gap-2 d-md-flex justify-content-between gw-header sticky-sm-top">
    <a href="{{ homeUrl }}">
      <img class="logo align-self-center ps-3" src="opportunity-logo.png" height="70px" alt="Groundworks Call Center" />
    </a>
    <div class="affiliate col-4 align-self-center fw-bold text-center">
      {{ brandName }}<span *ngIf="branchName">, {{ branchName }}</span>
      <span *ngIf="callbackNumber"> | {{ callbackNumber | mask: '(000) 000-0000' }}</span>
    </div>
    <div class="user-details-wrapper col-2">
      <div class="user-details">
        <div class="user-name">
          <span *ngIf="!configService.production" class="badge badge-pill bg-danger" id="environment-badge">{{
            configService.env
            }}</span>
          <span class="dropdown">
            <button class="btn btn-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="true"
              aria-expanded="false">{{ whoami }}</button>
            <div class="dropdown-menu" style="z-index: 1100;">
              <button class="dropdown-item" (click)="logout()">Logout</button>
            </div>
          </span>
        </div>
        <div class="user-image"></div>
      </div>
    </div>
  </div>
  <router-outlet />
</main>
